<fgb-account-layout titleKey="account.membership.title" titleDefault="Membership">
  <fgb-account-panel titleKey="account.membership.title" titleDefault="Membership">
    <fgb-membership-progress></fgb-membership-progress>
  </fgb-account-panel>
</fgb-account-layout>
